import $ from 'jquery';

export default function() {
  $('.js_qa_form').formValidation();

  var userFields = $('.js_qa_form_user_fields');
  var expandUserFields = $('.js_qa_form_expand');

  expandUserFields.on('click', function(e) {
      e.preventDefault();
      userFields.slideDown(200);
      expandUserFields.slideUp(200);
  });

  $('.js_form_textarea').textareaAutoSize();
}
